<template>
	<div>
		<app-bar />
		<v-container>
			<v-row
				justify="center"
				class="mt-5"
				:class="{
					'mt-7': !$vuetify.breakpoint.mdAndDown,
				}"
				no-gutters
			>
				<v-col cols="12" lg="12" xl="11">
					<router-view />
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
	import AppBar from "@/components/dashboard/DbAppBar";
	import { mapState } from "vuex";

	export default {
		components: {
			AppBar,
		},
		data() {
			return {
				drawer: null,
				items: [
					{
						title: "MENU",
						items: [
							{ title: "Dashboard", icon: "mdi-view-dashboard" },
							{ title: "Investments", icon: "mdi-image" },
							{ title: "Landbank", icon: "mdi-help-box" },
							{ title: "Homes", icon: "mdi-image" },
							{ title: "Wallet", icon: "mdi-help-box" },
							{ title: "Referals", icon: "mdi-help-box" },
						],
					},
					{
						title: "ACCOUNT",
						items: [
							{ title: "Settings", icon: "mdi-view-dashboard" },
							{ title: "Profile", icon: "mdi-image" },
						],
					},
				],
				right: null,
			};
		},
		computed: {
			...mapState(["userObj"]),
		},
		methods: {
			checkIfVerified() {
				let result = this.userObj.emailverified;

				if (result) {
					this.$router.push({ name: "dashboard.index" });
				} else {
					this.$router.push({ name: "auth.verify-email" });
				}
			},
		},
	};
</script>
